export const INPUT_LIMIT_LENGTH = 5000;

export const OPEN_DELAY = 500;

export const TASK_TYPE = {
    TRANSLATION: 'AI_TRANSLATION',
    DISCLOSURE: 'AI_PATENT_DISCLOSURE',
};

export const HISTORY_DEFAULT_PAGE = 1;

export const HISTORY_LIST_LIMIT = 100;

export const TITLE_SLICE_LENGTH = 20;

export enum TRACK_EVENT_TYPE {
    AI_OAR = 'SS AI OAR',
    /**
     * 专利撰写(通用的默认名)
     */
    Drafting = 'SS AI Drafting',
    /**
     * 专利交底书
     */
    Disclosure = 'SS AI Patent Disclosure',
    /**
     * 专利说明书
     */
    Specification = 'SS AI Specification',
    /**
     * 翻译
     */
    Translation = 'SS AI Translation',
    /**
     * 查新报告
     */
    NoveltySearch = 'SS AI Novelty Search',
    /**
     * FTO 报告
     */
    FtoReport = 'SS AI FTO Report',
    /**
     * 外观FTO
     */
    DesignFTO = 'SS IP Image Search Agent',
    /**
     * 容量检查
     */
    AclLimit = 'SS Acl Limit',
    /**
     * 升级弹窗展示
     */
    EurekaUpgradePage = 'SS Eureka Upgrade Page'
}


/**
 * 显示剩余次数的阈值
 */
export const LOW_TIMES_THRESHOLD = 240;

/**
 * AI 翻译显示剩余次数的阈值
 */
export const LOW_TIMES_THRESHOLD_TRANSLATION = 130 * 10000;

/**
 * AI 交底书显示剩余次数的阈值
 */
export const LOW_TIMES_THRESHOLD_DISCLOSURE = LOW_TIMES_THRESHOLD;

/**
 * AI 说明书显示剩余次数的阈值
 */
export const LOW_TIMES_THRESHOLD_SPECIFICATION = LOW_TIMES_THRESHOLD;

/**
 * AI 查新报告显示剩余次数的阈值
 */
export const LOW_TIMES_THRESHOLD_NOVELTY_SEARCH = LOW_TIMES_THRESHOLD;

/**
 * AI FTO 显示剩余次数的阈值
 */
export const LOW_TIMES_THRESHOLD_FTO = LOW_TIMES_THRESHOLD;

